// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { validateNumberRange } from 'validators/common'

const validate = ({ bandwidth, throughput }) => {
  const err = {}

  if (bandwidth) {
    validateNumberRange(bandwidth, err, 'bandwidth')
  }

  if (throughput) {
    validateNumberRange(throughput, err, 'throughput')
  }

  return err
}

export default validate
